import React from 'react';
import './WelcomeSection.css';
import Navbar from '../Navbar/Navbar';
import { useNavigate } from 'react-router-dom';
import logo from '../../Assets/carrerup_allInOne_cover_NoBg.png';
import { useTranslation } from 'react-i18next';
import { MilitaryTechOutlined } from '@mui/icons-material';
import { FaAccessibleIcon, FaAd, FaSearch, FaUserFriends, FaUserSecret } from 'react-icons/fa';

const WelcomeSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <section className="wb-ai-hero" id="first-div">
        <div className="wb-ai-grid" aria-hidden="true" />
        <div className="wb-ai-aurora wb-ai-aurora-one" aria-hidden="true" />
        <div className="wb-ai-aurora wb-ai-aurora-two" aria-hidden="true" />
        <div className="wb-ai-stars" aria-hidden="true" />

        <div className="wb-ai-shell">
          <div className="wb-ai-copy">
            <div className="wb-ai-kicker">
              <span className="wb-ai-kicker-dot" />
              {t('website.heroKicker')}
            </div>

            <h1>
              {t('website.heroTitle')}<br />
              <span>{t('website.heroHighlight')}</span>
            </h1>

            <p className="wb-ai-description">
              {t('welcomeSubText')}
            </p>

            <div className="wb-ai-actions">
              <button className="wb-ai-cta" onClick={() => navigate('/register')}>
                {t('start')} <span aria-hidden="true">→</span>
              </button>
              <div className="wb-ai-proof">
                <span className="wb-ai-proof-pulse" />
                {t('website.heroProof')}
              </div>
            </div>

            <div className="wb-ai-metrics" aria-label="Atouts de la plateforme">
              <div><strong>360°</strong><span>{t('ecosystem')}</span></div>
              <div><strong>∞</strong><span>{t('website.ecosystems')}</span></div>
              <div><strong><FaSearch/> </strong><span>{t('featuress.searchTitle')}</span></div>
            </div>
          </div>

          <div className="wb-ai-visual" aria-label="Visualisation du réseau CarrerUp">
            <div className="wb-ai-orbit wb-ai-orbit-one" />
            <div className="wb-ai-orbit wb-ai-orbit-two" />
            <div className="wb-ai-orbit wb-ai-orbit-three" />

            <div className="wb-ai-core">
              <div className="wb-ai-core-glow" />
              <img src={logo} alt="CarrerUp" />
              {/* <span className="wb-ai-core-label">CARRERUP<br /><b>INTELLIGENCE</b></span> */}
            </div>

            <div className="wb-ai-node wb-ai-node-athlete"><i />{t('athlete')}</div>
            <div className="wb-ai-node wb-ai-node-club"><i />{t('club')}</div>
            <div className="wb-ai-node wb-ai-node-agent"><i />{t('agent')}</div>
            <div className="wb-ai-node wb-ai-node-media"><i />{t('media')}</div>
            <div className="wb-ai-node wb-ai-node-sponsor"><i />{t('sponsor')}</div>
            <div className="wb-ai-node wb-ai-node-fan"><i />{t('fan')}</div>

            <div className="wb-ai-signal wb-ai-signal-one" />
            <div className="wb-ai-signal wb-ai-signal-two" />
            <div className="wb-ai-signal wb-ai-signal-three" />

            <div className="wb-ai-insight wb-ai-insight-top">
              <span className="wb-ai-insight-icon">✦</span>
              <div><small></small><strong>{t('websiteUi.opportunityDetected')}</strong></div>
              <em>98%</em>
            </div>
            <div className="wb-ai-insight wb-ai-insight-bottom">
              <span className="wb-ai-live-dot" />
              <div><small>{t('websiteUi.live')}</small><strong>+24 {t('website.ecosystems')}</strong></div>
            </div>
          </div>
        </div>

        <div className="wb-ai-scroll" aria-hidden="true"><span /> {t('websiteUi.explore')}</div>
      </section>
    </>
  );
};

export default WelcomeSection;
